import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { NewsModel } from '../../models/news';
import { NewsService } from '../../services/news.service';
import { PictureService } from '../../services/picture.service';
import { AuthService } from 'src/services/guard/auth.service';
import { Picture } from 'src/models/picture';
import { ConfirmationService } from 'primeng/api';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent extends BaseComponent implements OnInit {
  lastArticle: NewsModel;
  articles: NewsModel[];

  newsModel: NewsModel;
  modalRef: BsModalRef;
  pictureToRemove: Picture;

  constructor(
    protected pictureService: PictureService,
    translate: TranslateService,
    private newsService: NewsService,
    authService: AuthService,
    private modalService: BsModalService,
    private cd: ChangeDetectorRef,
    private toast: ToastrService,
    private confirm: ConfirmationService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);

  }

  ngOnInit(): void {
    this.newsService.getNews().subscribe(news => {
      news.forEach(article => {
        this.pictureService.getPictureForNews(article.id).subscribe(p => {
          article.picture = p;
        });
      });
      this.lastArticle = news[0];
      this.articles = news.slice(1);
    });
  }

  getProperty(news: NewsModel, property: string) {
    const lang = this.translate.currentLang.charAt(0).toUpperCase() + this.translate.currentLang.slice(1);
    return news[property + lang];
  }

  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      const files = event.target.files;
      if (!this.newsModel.id) {
        this.newsModel.picture = new Picture();
      }
      for (let file of files) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
          const picture: Picture = new Picture();
          picture.order = 0;
          picture.displayName = 'news';
          picture.file = <File>file;
          this.newsModel.picture = picture;

          // need to run CD since file load runs outside of zone
          this.cd.markForCheck();
        };
      }
    }
  }

  getPictureName(path: string) {
    if (path) {
      const replaced = path.replace('/', '\\').replace('Resources\\Pictures\\', '');
      const idx = replaced.indexOf('_');
      return replaced.slice(idx + 1);
    }
  }

  newsModal(template: TemplateRef<any>, news: NewsModel = null) {
    if (!this.isAdmin) {
      return;
    }
    if (!news) {
      news = new NewsModel();
    }
    this.newsModel = Object.assign({}, news);
    this.modalRef = this.modalService.show(template, { class: 'large' });
  }

  saveNews() {
    if (this.newsModel.id) {
      this.pictureService.removePicture(this.pictureToRemove).subscribe(() => {
        this.newsService.updateNews(this.newsModel).subscribe(
          () => this.toast.success('Article updated!'),
          err => {
            console.error(err);
            this.toast.error('An error occured');
          },
          () => {
            this.ngOnInit();
            this.modalRef.hide();
          }
        );
      });
    } else {
      this.newsService.addNews(this.newsModel).subscribe(
        () => this.toast.success('Article created!'),
        err => {
          console.error(err);
          this.toast.error('An error occured');
        },
        () => {
          this.ngOnInit();
          this.modalRef.hide();
        }
      );
    }
  }

  removePictureFromNews(picture: Picture) {
    if (this.newsModel.id) {
      this.pictureToRemove = picture;
    }
    this.newsModel.picture = null;
  }

  deleteNews() {
    this.confirm.confirm({
      message: 'Are you Sure?',
      accept: () => {
        this.newsService.deleteNews(this.newsModel).subscribe(
          () => this.toast.success('Article deleted!'),
          err => {
            console.error(err);
            this.toast.error('An error occured');
          },
          () => {
            this.ngOnInit();
            this.modalRef.hide();
          }
        );
      }
    });
  }

  close() {
    this.modalRef.hide();
  }

}
